<template>
    <div>
        <div>
            <el-tooltip
                effect="dark"
                content="取消时效优先标识"
                placement="bottom"
            >
                <span class="mgl-2">
                    <el-button
                        v-has="'dispatchCenter-cancelTimePriority'"
                        icon="el-icon-document-checked"
                        size="mini"
                        @click="cancelTimePriority"
                        class="icon-change"
                    ></el-button>
                </span>
            </el-tooltip>
            <el-tooltip effect="dark" content="修改配送方式" placement="bottom">
                <span v-has="'otp04010007'" class="mgl-5 bigData-btn-delivery">
                <el-button icon="el-icon-s-operation" size="mini" @click="handleDelivery"></el-button>
                </span>
            </el-tooltip>
            <el-tooltip effect="dark" content="取消分拨" placement="bottom">
                <span v-has="'otp04010006'" class="mgl-5 bigData-btn-cancel-allocation">
                    <el-button icon="el-icon-c-scale-to-original" size="mini" @click="handleCancleAllocate"></el-button>
                </span>
            </el-tooltip>
        </div>
        <RevocationDialog ref="revocationDialog" v-if="revocationShow" :revocationShow.sync="revocationShow" @confirm="revocationConfirm"></RevocationDialog>
        <advanceDialog ref="advanceDialog" @confirm="advanceDialogConfirm" rejectClose></advanceDialog>
        <delivery-methods v-if="deliveryDialogShow" :deliveryDialogVisiable.sync="deliveryDialogShow" :checkedSourceList="checkedSourceList"
        @deliveryClose="deliveryClose" @deliveryOk="deliveryOk"></delivery-methods>
         <!-- 取消时效优先标识弹窗 -->
         <cancel-task-dialog
            v-if="cancelTaskDialogVisible"
            :visible.sync="cancelTaskDialogVisible"
            :tasks="checkedSourceList"
            @confirm="handleCancelTaskDialogConfirm"
        />
    </div>
</template>
<script>
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import RevocationDialog from './dialog/Revocation';
import DeliveryMethods from './dialog/DeliveryMethods';
import CancelTaskDialog from './dialog/CancelTaskDialog';

import {
    issueCarrier,
    getCancleAllocate,
    confirmIssueCarrier
} from '../../../api/dispatchCenter';
import { verifyLBXOrder, getMesTip } from '../../../utils/dispatchCenter.js';
export default {
    props: {
        checkedSourceList: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    components: { RevocationDialog, advanceDialog, DeliveryMethods, CancelTaskDialog },
    data() {
        return {
            revocationShow: false,
            deliveryDialogShow: false,
            cancelTaskDialogVisible: false
        };
    },
    methods: {
        cancelTimePriority () {
            if (this.checkedSourceList.length < 1) return this.$message.warning('请勾选运输单后再进行点击');
            this.cancelTaskDialogVisible = true;
        },
        handleCancelTaskDialogConfirm () {
            this.$emit('refreshList');
            this.cancelTaskDialogVisible = false;
        },
        revocation() {
            if (this.checkedSourceList.length === 0) {
                this.$message.warning('请勾选运输单');
                return false;
            }
            const reject = this.checkedSourceList.find(item => item.carrierVisibleFlag === 'N');
            if (reject) {
                this.$message.warning({
                    message: `运输单号：${reject.taskNo} 未下发，无法撤回`,
                    duration: 5000
                });
                return false;
            }
            const reject2 = this.checkedSourceList.find(item => item.taskStatus !== 0);
            if (reject2) {
                this.$message.warning({
                    message: `运输单号：${reject2.taskNo} 非待调度运单，无法撤回`,
                    duration: 5000
                });
                return false;
            }
            const verifyLBXOrderRes = verifyLBXOrder(this.checkedSourceList);
            if (getMesTip(verifyLBXOrderRes, this)) { return; }
            this.revocationShow = true;
        },
        // 下发 1
        issued() {
            if (this.checkedSourceList.length === 0) {
                this.$message.warning('请勾选运输单');
                return false;
            }
            const reject = this.checkedSourceList.find(item => item.carrierVisibleFlag === 'Y');
            if (reject) {
                this.$message.warning({
                    message: `运输单号：${reject.taskNo} 已下发，不能重复下发`,
                    duration: 5000
                });
                return false;
            }
            const reject2 = this.checkedSourceList.find(item => item.taskStatus !== 0);
            if (reject2) {
                this.$message.warning({
                    message: `运输单号：${reject2.taskNo} 非待调度运单，无法下发`,
                    duration: 5000
                });
                return false;
            }
            const verifyLBXOrderRes = verifyLBXOrder(this.checkedSourceList);
            if (getMesTip(verifyLBXOrderRes, this)) { return; }
            setTimeout(() => {
                this.checkedSourceList.forEach((item, index, arr) => {
                    if (item.consolidationOrderNo && item.consolidationNum) {
                        const totalCount = arr.filter(item2 => item2.consolidationOrderNo === item.consolidationOrderNo).length;
                        if (totalCount < item.consolidationNum) {
                            this.$message.warning({
                                message: `集拼单号：${item.consolidationOrderNo}未齐套,集拼单量应为：${item.consolidationNum}个,目前只勾选${totalCount}个，如有疑问请咨询基地！`,
                                duration: 5000
                            });
                        }
                    }
                });
            }, 50);
            this.showAdvanceDialog();
        },
        //  下发 2
        showAdvanceDialog() {
            const options = {
                name: '请输入承运商',
                advanceLabel: '承运商',
                value: 'carrierName',
                advanceConfig: [
                    { prop: 'supplierNameCn', value: '承运商名称' },
                    { prop: 'supplierCode', value: '承运商编码' }
                ],
                tableConfig: [
                    { prop: 'supplierNameCn', value: '承运商名称' },
                    { prop: 'supplierCode', value: '承运商编码' },
                    { prop: 'transNameListStr', value: '采购渠道' }
                ],
                advanceNotSearch: true,
                queryConditionRequired: true,
                method: 'post',
                advanceUrl: 'srm/supplier/search',
                prefix: '/api-tms/',
                cbParams: [
                    'supplierNameCn#carrierName', 'supplierCode#carrierCode', 'transTypeListStr#procurementChannel', 'transNameListStr#procurementChannelName'
                ]
            };
            this.$refs.advanceDialog.show(true, options);
        },
        // 撤回 2
        revocationConfirm(data) {
            this.$confirm('你确定要撤回吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs.revocationDialog.loading();
                const params = {
                    carrierVisibleFlag: 'N',
                    taskNos: [],
                    ...data
                };
                this.checkedSourceList.forEach(item => params.taskNos.push(item.taskNo));
                issueCarrier(params).then(res => {
                    if (res) {
                        this.checkedSourceList.forEach(item => {
                            item.carrierVisibleFlagName = '否';
                            item.carrierVisibleFlag = 'N';
                            item.carrierName = '';
                            item.carrierCode = '';
                            item.procurementChannel = '';
                            item.procurementChannelName = '';
                        });
                        this.$message.success('撤回成功');
                        this.$emit('refreshList');
                    }
                }).finally(() => {
                    this.revocationShow = false;
                });
            }).catch(() => {});
        },
        // 承运商弹框返回值  做下发操作  下发 3
        advanceDialogConfirm(data) {
            const params = {
                carrierVisibleFlag: 'Y',
                taskNos: [],
                ...data
            };
            this.checkedSourceList.forEach(item => params.taskNos.push(item.taskNo));
            issueCarrier(params).then(res => {
                if (res) {
                    const successHandle = () => {
                        this.checkedSourceList.forEach(item => {
                            item.carrierVisibleFlagName = '是';
                            item.carrierVisibleFlag = 'Y';
                            item.carrierName = data.carrierName;
                            item.carrierCode = data.carrierCode;
                            item.procurementChannel = data.procurementChannel;
                            item.procurementChannelName = data.procurementChannelName;
                        });
                        this.$message.success('下发成功');
                        this.$refs.advanceDialog.dialogVisible = false;
                        this.$emit('refreshList');
                    };
                    if (res.data.flag !== 0) {
                        const tipArr = res.data.msg.split(',');
                        this.$confirm(tipArr.join('<br />') + '<br />' + '你确定要下发吗?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            dangerouslyUseHTMLString: true,
                            type: 'warning'
                        }).then(() => {
                            confirmIssueCarrier(params).then(res => {
                                if (res) {
                                    successHandle();
                                }
                            }).catch(() => {
                            });
                        }).catch(() => {
                            this.$refs.advanceDialog.disabledCancel = false;
                        });
                        return false;
                    }
                    successHandle();
                }
            }).catch(() => {
            });
        },
        handleDelivery() { // 更改网点配送方式
            if (this.checkedSourceList.length < 1) return this.$message.warning('请选择待调度的运输单进行操作');
            if (this.checkedSourceList.some(v => v.businessMode === 'B2C')) return this.$message.warning('B2C订单不允许修改配送方式！');
            let deliveryTypeCount = 0;
            let deliveryCount = 0;
            let netCount = 0;
            let distributionFlagCount = 0;
            let distributionLastFlagCount = 0;
            this.checkedSourceList.forEach(item => {
                if (item.deliveryType === 'DELIVERY') ++deliveryCount;
                if (item.deliveryType === 'NET') ++netCount;
                if (item.deliveryType !== 'DELIVERY' && item.deliveryType !== 'NET') ++deliveryTypeCount;
                if (item.distributionFlag !== 'Y') ++distributionFlagCount;
                if (item.distributionLastFlag === 'N') ++distributionLastFlagCount;
            });
            if (deliveryTypeCount > 0) return this.$message.warning('只有网点配送和配送的单才能修改配送方式');
            if (netCount !== 0 && netCount !== this.checkedSourceList.length) return this.$message.warning('存在不同配送方式的运输单');
            if (deliveryCount > 0 && deliveryCount !== this.checkedSourceList.length && distributionFlagCount > 0) {
                return this.$message.warning('是否分拨最后一段为Y，配送方式为配送的单才能修改');
            }
            if (distributionLastFlagCount > 0) return this.$message.warning('非最后一段不允许修改配送方式');
            const verifyLBXOrderRes = verifyLBXOrder(this.checkedSourceList);
            if (getMesTip(verifyLBXOrderRes, this)) { return; }
            this.deliveryDialogShow = true;
        },
        deliveryClose() {
            this.deliveryDialogShow = false;
        },
        deliveryOk() {
            this.deliveryDialogShow = false;
            this.$emit('refreshList');
        },
        handleCancleAllocate() {
            if (this.checkedSourceList.length < 1) return this.$message.warning('请选择待调度的运输单进行操作');
            let cancleAllocateCount = 0;
            this.checkedSourceList.forEach(item => {
                if ((item.orderType === 'RI' && ['IN', 'DI', 'RDI'].includes(item.taskType)) || item.distributionFlag === 'N') ++cancleAllocateCount;
            });
            if (cancleAllocateCount) return this.$message.warning('存在不能取消分拨的单！');
            const verifyLBXOrderRes = verifyLBXOrder(this.checkedSourceList);
            if (getMesTip(verifyLBXOrderRes, this)) { return; }
            this.$confirm('是否确认取消分拨？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const taskNos = this.checkedSourceList.map(el => el.taskNo);
                getCancleAllocate({ taskNos: taskNos }).then(res => {
                    if (res) {
                        this.$message({
                            showClose: true,
                            message: res.msg || '已取消分拨',
                            type: 'success',
                            duration: 5000
                        });
                        this.$emit('refreshList');
                    };
                });
            }).catch(() => {});
        }
    }
};
</script>
